"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BANDWIDTH_ESTIMATION_HYBRID_CONFIG = {
    defaultBandwidthEstimate: 500000,
    //   before completing any Segment downloads
    historySize: 3,
    minLoad: 35000,
    //   (i.e. attempt to ignore small audio fragments)
    minDuration: 50 // minimum duration of fragment download for 'Simple'
    //   bandwith estimation (milliseconds)
};
exports.default = BANDWIDTH_ESTIMATION_HYBRID_CONFIG;
//# sourceMappingURL=BANDWIDTH_ESTIMATION_HYBRID_CONFIG.js.map